import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useCoachRole = () => {
  return useQuery({
    queryKey: ['coach-role'],
    queryFn: async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return false;

      const { data, error } = await supabase
        .from('user_roles')
        .select('role')
        .eq('user_id', user.id)
        .eq('role', 'coach')
        .maybeSingle();

      if (error) {
        console.error('Error checking coach role:', error);
        return false;
      }

      return !!data;
    }
  });
};
